import { render, staticRenderFns } from "./ManageSubscriptionSidebar.vue?vue&type=template&id=533c2564&scoped=true"
import script from "./ManageSubscriptionSidebar.vue?vue&type=script&lang=js"
export * from "./ManageSubscriptionSidebar.vue?vue&type=script&lang=js"
import style0 from "./ManageSubscriptionSidebar.vue?vue&type=style&index=0&id=533c2564&prod&lang=scss"
import style1 from "./ManageSubscriptionSidebar.vue?vue&type=style&index=1&id=533c2564&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533c2564",
  null
  
)

export default component.exports